<div class="form-group" [ngClass]="field.customClass">
  <label [for]="'field' + field.name">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? "*" : "" }}</span>
  </label>
  <textarea
    [name]="field.name"
    [placeholder]="field.inputPlaceholder || ''"
    [formControl]="control"
    class="form-control"
    [class.is-invalid]="(control.touched || control.value) && control.errors"
    [class.is-valid]="control.touched && control.value"
    [rows]="field.rows"
    [id]="'field' + field.name"
    [attr.disabled]="disabled || null"
  ></textarea>
</div>
